export let globalDeployEnv = null;
export let globalIsCloudFeatureBranch = false;
export let globalImageProxyBaseUrl = '';
export let topLevelDialogSetFunc = null;
export let guardrailsDialogSetFunc = null;
export let isSessionTimeoutWarningActive = false;

export function setSessionTimeoutWarningActive(active) {
  isSessionTimeoutWarningActive = active;
}

export function setGlobalDeployEnv(newEnv) {
  globalDeployEnv = newEnv;
}

export function setGlobalIsCloudFeatureBranch(isCloudFeatureBranch) {
  globalIsCloudFeatureBranch = isCloudFeatureBranch;
}

export function setGlobalImageProxyBaseUrl(url) {
  globalImageProxyBaseUrl = url;
}

// Getter form is required: a previous attempt to read the binding directly
// via `import { globalImageProxyBaseUrl }` saw stale `null` in vitest because
// the project's ESM transpilation doesn't propagate `export let` mutations
// through named imports / namespace properties. This getter reads on demand
// from the module's closure and works in both vitest and runtime.
export function getGlobalImageProxyBaseUrl() {
  return globalImageProxyBaseUrl;
}

export function setTopLevelDialogSetFunc(func) {
  topLevelDialogSetFunc = func;
}

export const openTopLevelDialog = ({
  title,
  message,
  contentComponent = null,
  showOkButton = false,
  isSessionTimeout = false,
}) => {
  if (!topLevelDialogSetFunc) {
    // eslint-disable-next-line no-console
    console.log("Can't open top level dialog, function wasn't set yet");
    return;
  }

  topLevelDialogSetFunc({ title, message, contentComponent, showOkButton, isSessionTimeout });
};

export function setGuardrailsDialogSetFunc(func) {
  guardrailsDialogSetFunc = func;
}

// Promise-based sibling of `openTopLevelDialog`: the guardrails interceptor is plain
// (non-React) code, so it opens the warn/block dialog imperatively and awaits the user's
// decision. Resolves `{ proceed, reason }`. If no host is mounted (function never set),
// it resolves as a cancel — the interceptor then surfaces the original error, exactly
// the pre-guardrails behavior.
export const openGuardrailsDialog = ({ violations, isBlocked }) =>
  new Promise((resolve) => {
    if (!guardrailsDialogSetFunc) {
      // eslint-disable-next-line no-console
      console.log("Can't open guardrails dialog, function wasn't set yet");
      resolve({ proceed: false, reason: '', dialogShown: false });
      return;
    }
    guardrailsDialogSetFunc({
      violations,
      isBlocked,
      resolve: (result) => resolve({ ...result, dialogShown: true }),
    });
  });
